import classNames from 'classnames';
import BEM from 'common/bem';

const classes = BEM.with('StatusBar');

type StatusBarProps = {
  children: React.ReactNode;
  variant?: 'success' | 'warning' | 'error' | 'neutral';
  className?: string;
};

function StatusBar({ children, variant = 'neutral', className }: StatusBarProps) {
  return <div className={classNames(className, classes({ variant }))}>{children}</div>;
}

export default StatusBar;
